<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>

<ng-container *ngIf="ready">

  <div class="dlg-hdr">
    <div class="dlg-hdr__title">
      <div class="dlg-hdr__icon-wrap"><mat-icon>account_balance</mat-icon></div>
      <div>
        <span>Constitución del crédito</span>
      </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dlg-body">
    <ng-container *ngIf="depositSaved === false">
      <div class="row">
        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <mat-label>Corto/Largo Plazo</mat-label>
            <mat-select placeholder="Corto/Largo Plazo" panelclass="general-v2-mat-select"
              [(ngModel)]="constitucionDelCreditoCreditosConEmpleados.plazo" name="plazo"
              (selectionChange)="plazoChangeValue($event.value)" required>
              <mat-option [value]="0">
                Sin seleccionar
              </mat-option>
              <mat-option [value]="1">
                Corto Plazo
              </mat-option>
              <mat-option [value]="2">
                Largo Plazo
              </mat-option>
            </mat-select>
            <mat-error *ngIf="invalidPlazo">Campo requerido</mat-error>
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="Paided" placeholder=""
              name="constitucionDelCreditoCreditosConEmpleados.fecha" required
              [(ngModel)]="constitucionDelCreditoCreditosConEmpleados.fecha" />
            <mat-datepicker-toggle matSuffix [for]="Paided"></mat-datepicker-toggle>
            <mat-datepicker #Paided></mat-datepicker>
            <mat-error *ngIf="invalidDate">Campo requerido</mat-error>
          </mat-form-field>
        </div>

        <div class="col-4">
          <app-input inputType="text" placeholder="Concepto" [isRequired]="true"
            [(ngModel)]="constitucionDelCreditoCreditosConEmpleados.concepto"></app-input>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mt-2 mb-2">
            <input type="text" matInput placeholder="Importe"
              [(ngModel)]="constitucionDelCreditoCreditosConEmpleados.importe"
              value="constitucionDelCreditoCreditosConEmpleados.importe" class="" required numberDecimalsDirective>
            <mat-error *ngIf="invalidImporte">Campo requerido</mat-error>
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mt-2 mb-2">
            <input type="text" matInput placeholder="Comisión Apertura"
              [(ngModel)]="constitucionDelCreditoCreditosConEmpleados.comisionApertura"
              value="constitucionDelCreditoCreditosConEmpleados.comisionApertura" class="" numberDecimalsDirective>
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mt-2 mb-2">
            <input type="text" matInput placeholder="Gastos Bancarios"
              [(ngModel)]="constitucionDelCreditoCreditosConEmpleados.gastosBancarios"
              value="constitucionDelCreditoCreditosConEmpleados.gastosBancarios" class="" numberDecimalsDirective>
          </mat-form-field>
        </div>

        <!-- Actividades -->
        <div class="col-4">
          <app-autocomplete-select [items]="activities"
            [(selectedItemId)]="constitucionDelCreditoCreditosConEmpleados.activitiesUid" [idField]="'uid'"
            [displayField]="'name'" placeholder="Actividad">
          </app-autocomplete-select>
        </div>

        <div class="col-4">
          <app-autocomplete-select [items]="bankAccounts"
            [(selectedItemId)]="constitucionDelCreditoCreditosConEmpleados.bankAccountsUid" [idField]="'uid'"
            [displayFields]="['bank', 'iban']" placeholder="Cuentas bancarias">
          </app-autocomplete-select>
        </div>
      </div>
    </ng-container>

    <div class="delete-info delete-info--success" *ngIf="depositSaved === true">
      <mat-icon>check_circle</mat-icon>
      <div class="delete-info__text">
        Constitución {{ isEditMode === true ? 'actualizada': 'añadida' }} correctamente
      </div>
    </div>

    <!-- Listado -->
    <ng-container *ngIf="list == true">
      <div class="dlg-empty-list">Listado</div>

      <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="false" [hasButton]="true"
        [actionsTemplate]="actionsButtons">
      </app-table>

      <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
          <ul class="custom-class">
            <li (click)="edit(uid)">
              <a>
                <mat-icon>create</mat-icon> Editar
              </a>
            </li>
            <li (click)="delete(uid)">
              <a>
                <mat-icon>warning</mat-icon> Borrar
              </a>
            </li>
          </ul>
        </ng-container>
      </ng-template>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dlg-actions" *ngIf="depositSaved === false">
    <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
    <button mat-flat-button class="dlg-btn-save" (click)="pay()">
      <mat-icon>save</mat-icon>
      {{ isEditMode === true ? 'Actualizar' : 'Añadir'}}
    </button>
  </mat-dialog-actions>

</ng-container>
